import { AlertCircleIcon, Shield } from "lucide-react";

const DataSensitivityLabel: React.FC<{ type: string }> = ({ type }) => {
  if (type === "public") {
    return (
      <div className="flex items-center gap-1 bg-green-100 rounded-md px-[6px] py-[2px] text-green-700 shadow-xs">
        <Shield className="w-[12px] h-[12px] text-green-700" />
        <span className="text-xs font-medium">Public</span>
      </div>
    );
  }
  if (type === "internal") {
    return (
      <div className="flex items-center gap-1 bg-red-100 rounded-md px-[6px] py-[2px] text-red-700 shadow-xs">
        <AlertCircleIcon className="w-[12px] h-[12px] text-red-700" />
        <span className="text-xs font-medium">Internal</span>
      </div>
    );
  }
};

export default DataSensitivityLabel;
